// Measure the banner and header heights and set CSS variables used by CSS.

// It runs on load and resize, and throttles resize updates.

(function() {
  function setHeights() {
    var banner = document.querySelector('.site-header-banner');
    var header = document.querySelector('header.fixed-top, header, .site-header, .main-header, .fixed-top, #Header');
    var bannerHeight = banner ? Math.round(banner.offsetHeight) : 0;
    var headerHeight = header ? Math.round(header.offsetHeight) : 0;

    document.documentElement.style.setProperty('--banner-height', bannerHeight + 'px');
    document.documentElement.style.setProperty('--site-header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-and-banner-height', (bannerHeight + headerHeight) + 'px');
  }

  function throttle(fn, wait) {
    var time = Date.now();
    return function() {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now(); 
      }
    };
  }

  document.addEventListener('DOMContentLoaded', function() {
    setHeights();

    var imgs = document.querySelectorAll('.site-header-banner img');
    if (imgs.length) {
      var loaded = 0;
      imgs.forEach(function(img) {
        if (img.complete) { loaded++; }
        else {
          img.addEventListener('load', setHeights);
          img.addEventListener('error', setHeights);
        }
      });
      if (loaded === imgs.length) setHeights();
    }
  });

  window.addEventListener('resize', throttle(setHeights, 150));
})();